<template>
    <label class="relative flex flex-col gap-2  cursor-pointer w-max" id="storeVerification">
        <input :checked="isChecked" :true-value="1" :false-value="0" @input="(e) => onChange(+e.target.checked)"
            type="checkbox" class="sr-only peer" aria-label="storeVerification" aria-labelledby="storeVerification">
        <div
            class="w-11 h-6 relative bg-[#C1C1C1] rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 verified__checkbox peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] peer-checked:after:bg-[url(@/assets/icons/verify_icon.svg)] after:bg-[url(@/assets/icons/verify_gray.svg)] after:bg-center after:bg-no-repeat after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600">
        </div>
    </label>
</template>

<script>
export default {
    props: {
        isChecked: {
            type: [Boolean, Number],
            required: true,
            default: false
        }
    },
    methods: {
        onChange(isChecked) {
            this.$emit("onChange", isChecked);
        }
    }
}
</script>

<style scoped>
.verified__checkbox::after {
    background-size: 0.875rem;
}
</style>